export default import.meta.ROLLDOWN_FILE_URL_gAzsd6TCDgp86c4KxVAHMw